import {
  GET_DESPACHO,
  GET_DESPACHO_ERROR,
  GET_DESPACHO_SUCCESS,
  GET_PRODUCTION_TARGETS,
  GET_PRODUCTION_TARGETS_SUCCESS,
  GET_PRODUCTION_TARGETS_ERROR,
  SAVE_PRODUCTION_TARGETS,
  SAVE_PRODUCTION_TARGETS_SUCCESS,
  SAVE_PRODUCTION_TARGETS_ERROR,
} from './Despacho.actions';

const despachoState = {
  loading: true,
  error: undefined,
  fromPlatforms: null,
  toPlatforms: null,
  allRoutes: null,
  geofenceGroups: null,
  unassignedTrucks: null,
  targets: {},
  targetsLoading: false,
  targetsError: undefined,
  targetsSaving: false,
  excludedTrucks: null,
};

/**
 * The despacho reducer.
 */
const despachoReducer = (state = despachoState, { payload, type }) => {
  switch (type) {
    case GET_DESPACHO: {
      return { ...state, loading: true, error: undefined };
    }
    case GET_DESPACHO_ERROR: {
      return { ...state, loading: false, error: payload.error };
    }
    case GET_DESPACHO_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        fromPlatforms: payload.fromPlatforms,
        toPlatforms: payload.toPlatforms,
        allRoutes: payload.allRoutes,
        geofenceGroups: payload.geofenceGroups,
        unassignedTrucks: payload.unassignedTrucks,
        excludedTrucks: payload.excludedTrucks,
      };
    }
    case GET_PRODUCTION_TARGETS: {
      return { ...state, targetsLoading: true, targetsError: undefined };
    }
    case GET_PRODUCTION_TARGETS_SUCCESS: {
      return {
        ...state,
        targetsLoading: false,
        targetsError: undefined,
        targets: payload.targets,
      };
    }
    case GET_PRODUCTION_TARGETS_ERROR: {
      return {
        ...state,
        targetsLoading: false,
        targetsError: payload.error,
      };
    }
    case SAVE_PRODUCTION_TARGETS: {
      return { ...state, targetsSaving: true, targetsError: undefined };
    }
    case SAVE_PRODUCTION_TARGETS_SUCCESS: {
      return {
        ...state,
        targetsSaving: false,
        targetsError: undefined,
        targets: payload.targets,
      };
    }
    case SAVE_PRODUCTION_TARGETS_ERROR: {
      return {
        ...state,
        targetsSaving: false,
        targetsError: payload.error,
      };
    }
    default: {
      return state;
    }
  }
};

export default despachoReducer;
